var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-slide-list',{attrs:{"items":_vm.items,"width":"200"},scopedSlots:_vm._u([{key:"item",fn:function({ item, index }){return [(index <= 25)?_c('item',{attrs:{"value":item}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }